import React, { useState } from "react";
import ProfileDisplay from "./../components/ProfileViewComponent";
import ProfileEdit from "./../components/ProfileEditComponent";

const ProfileVersionTwo: React.FC = () => {
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const handleEditClick = () => setIsEditing(true);
  const handleCancel = () => setIsEditing(false);
  const handleSave = () => {
    // Implement save logic here
    setIsEditing(false);
  };

  return (
    <div style={{ overflow: "hidden" }}>
      {isEditing ? (
        <ProfileEdit
          onCancel={handleCancel}
          onSave={handleSave}
          isFormDisabled={false}
        />
      ) : (
        <ProfileDisplay onEdit={handleEditClick} />
      )}
    </div>
  );
};

export default ProfileVersionTwo;
